import React from 'react';
import { useLanguage } from '../context/LanguageContext';

function SettingsPage() {
  const { t } = useLanguage();

  const styles = {
    card: {
      backgroundColor: 'white',
      borderRadius: '10px',
      padding: '30px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      maxWidth: '800px',
      margin: '0 auto',
    },
    title: {
      textAlign: 'center',
      marginBottom: '30px',
      color: '#333',
      fontSize: '28px',
      fontWeight: 'bold',
    },
    content: {
      textAlign: 'center',
      fontSize: '18px',
      color: '#666',
      marginBottom: '30px',
    },
    placeholder: {
      backgroundColor: '#f8f9fa',
      padding: '40px',
      borderRadius: '8px',
      border: '2px dashed #dee2e6',
      textAlign: 'center',
      color: '#6c757d',
      fontSize: '16px',
    },
  };

  return (
    <div style={styles.card}>
      <h1 style={styles.title}>{t('settings')}</h1>
      <p style={styles.content}>
        {t('hello')}! {t('settings')} {t('pleaseWait')}
      </p>
      <div style={styles.placeholder}>
        ⚙️ {t('settings')} {t('loading')}...
        <br />
        <small>This feature is coming soon!</small>
      </div>
    </div>
  );
}

export default SettingsPage; 